var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-900 text-white min-h-screen"},[_c('Nav'),(_vm.$route.path === '/')?_c('Banner',{attrs:{"movies":_vm.popularMovies}}):_vm._e(),_c('div',{staticClass:"container mx-auto mt-24 md:mt-16"},[_c('router-view',{key:_vm.$route.path})],1),_c('vue-progress-bar'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }